/**
 * 退改程序功能路由
 * */
export default {
  ticket: {
    key: 'ticket',
    name: '',
    path: '/ticket',
    child: {
      updateDetail: {
        key: 'updateDetail',
        name: '机票退改',
        path: '/ticket/updateDetail',
      },
      search: {
        key: 'search',
        name: '退改搜索',
        path: '/ticket/search',
      },
      addPersonMessage: {
        key: 'addPersonMessage',
        name: '补充旅客信息',
        path: '/ticket/addPersonMessage',
      },
      addProductShop: {
        key: 'addProductShop',
        name: '推荐服务',
        path: '/ticket/addProductShop',
      },
      realNameVerify: {
        key: 'realNameVerify',
        name: '退款账户认证',
        path: '/ticket/realNameVerify',
      },
      reformProcess: {
        key: 'ReformProcess',
        refundName: '退票详情',
        changeName: '变更详情',
        refundSeat: '取消行程详情',
        path: '/ticket/ReformProcess',
      },
      ticketChange: {
        key: 'TicketChange',
        name: '',
        path: '/ticket/TicketChange',
      },
      endorsedApply: {
        key: 'EndorsedApply',
        changeName: '变更申请',
        refundName: '退票申请',
        refundSeat: '取消行程申请',
        path: '/ticket/EndorsedApply',
      },
      selectDate: {
        key: 'selectDate',
        refundName: '选择航班日期',
        changeName: '选择航班日期',
        path: '/ticket/selectDate',
      },
      applySubmit: {
        key: 'ApplySubmit',
        refundName: '退票申请',
        refundSeat: '取消行程申请',
        changeName: '机票变更',
        path: '/ticket/ApplySubmit',
      },
      loginFeeQuery: {
        key: 'loginFeeQuery',
        name: '退改费用查询',
        path: '/ticket/loginFeeQuery',
      },
      feeQuery: {
        key: 'feeQuery',
        name: '退改费用查询',
        path: '/ticket/feeQuery',
        childs: {
          login: {
            key: 'login',
            name: '退改费用查询',
            path: '/ticket/feeQuery/login',
          },
          list: {
            key: 'list',
            name: '退改费用查询',
            path: '/ticket/feeQuery/list',
          },
          detail: {
            key: 'detail',
            name: '退改费用查询',
            path: '/ticket/feeQuery/detail',
          },
        },
      },
      ticketFeeQuery: {
        key: 'ticketFeeQuery',
        name: '退改费用查询',
        path: '/ticket/ticketFeeQuery',
      },
      changeFlight: {
        key: 'changeFlight',
        name: '优惠推荐',
        path: '/ticket/changeFlight',
      },
      easyLogin: {
        key: 'easyLogin',
        name_easy: '退改/升舱',
        name_more: '机票退改',
        path: '/ticket/easyLogin',
      },
      pay: {
        key: 'pay',
        name: '支付结果',
        path: '/ticket/pay',
      },
      electronicInvoice: {
        key: 'electronicInvoice',
        name: '电子发票',
        path: '/ticket/electronicInvoice',
      },
      officialTicket: {
        key: 'officialTicket',
        name: '公务员信息认证',
        path: '/ticket/officialTicket',
      },
      moreInvoice: {
        key: 'moreInvoice',
        name: '我的电子发票',
        path: '/ticket/moreInvoice',
      },
      invoiceDetails: {
        key: 'invoiceDetails',
        name: '查看',
        path: '/ticket/invoiceDetails',
      },
      coupon: {
        key: 'coupon',
        name: '优惠券',
        path: '/ticket/coupon',
      },
      refundCoupon: {
        key: 'refundCoupon',
        name: '退票优惠券',
        path: '/ticket/refundCoupon',
      },
      refundApply: {
        key: 'refundApply',
        name: '退票申请',
        path: '/ticket/refundApply',
      },
      faceRecognition: {
        key: 'faceRecognition',
        name: '微信人脸识别认证',
        path: '/ticket/faceRecognition',
      },
      certificationResults: {
        key: 'certificationResults',
        name: '微信人脸识别认证',
        path: '/ticket/certificationResults',
      },
      wrongPurchase: {
        key: 'wrongPurchase',
        name: '错购申请',
        path: '/ticket/wrongPurchase',
      },
      viewProgress: {
        key: 'viewProgress',
        name: '查看进度',
        path: '/ticket/viewProgress',
      },
      facemoreQurey: {
        key: 'facemoreQurey',
        name: '更多查询',
        path: '/ticket/facemoreQurey',
      },
      // changeRefundExplain: {
      //   key: 'changeRefundExplain',
      //   name: '退改说明',
      //   path: '/ticket/changeRefundExplain',
      // },
      changeRefundExplain: {
        key: 'changeRefundExplain',
        name: '退改说明',
        path: '/ticket/changeRefundExplain',
        childs: {
          list: {
            key: 'list',
            name: '退改费用查询',
            path: '/ticket/changeRefundExplain/list',
          },
          detail: {
            key: 'detail',
            name: '退改费用查询',
            path: '/ticket/changeRefundExplain/detail',
          },
        },
      },
      cancelLation: {
        key: 'cancelLation',
        name: '取消行程',
        path: '/ticket/cancelLation',
      },
      // GN: [ID1678500][2024-11-26]
      discountTicketApplication: {
        key: 'discountTicketApplication',
        name: '降价客票申请',
        path: '/ticket/discountTicketApplication',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/config/routerConfig.js